import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    BusyableButtonComponent,
    MultiSelectionControlComponent,
    PhoneInputComponent,
    SingleSelectionControlComponent,
    SsnInputComponent
} from './components';
import { DialogContentComponent } from './dialog/dialog-content.component';
import { FooterComponent, HeaderComponent, SidenavComponent } from './layout';
import { MaterialModule } from './material/material.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';

@NgModule({
    declarations: [
        FooterComponent,
        HeaderComponent,
        SidenavComponent,
        DialogContentComponent,
        BusyableButtonComponent,
        PhoneInputComponent,
        SsnInputComponent,
        MultiSelectionControlComponent,
        SingleSelectionControlComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule,
        TranslocoRootModule,
        RouterModule
    ],
    exports: [
        FlexLayoutModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule,
        FooterComponent,
        HeaderComponent,
        SidenavComponent,
        TranslocoRootModule,
        DialogContentComponent,
        BusyableButtonComponent,
        PhoneInputComponent,
        SsnInputComponent,
        MultiSelectionControlComponent,
        SingleSelectionControlComponent
    ]
})
export class SharedModule {}
